<template>
  <!--
  <svg :x="`${svg.x}%`" :y="`${svg.y}%`" :width="`${svg.width}%`" :height="`${svg.height}%`" class="canvas">
  -->
  <svg width="100%" height="100%">

    <!-- debugger
    <rect x="0" y="0" width="100%" height="100%" style="stroke:green; stroke-width:1; fill:none;"/>
     -->

    <!--
    SVG с искожаемым контентом при измении соотношения сторон
    тут размещаем график. Если меток не нужно то этот SVG можно сделать родительским
    -->
    <svg x="0" y="0" width="100%" height="100%"
      :viewBox="`${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`"
      preserveAspectRatio="none" fill="transparent">
      <!-- debugger
      <rect x="0" y="0" width="100%" height="100%" style="stroke:red; stroke-width:1; fill:none;"/>
      -->

      <!-- серединная линия stack -->
      <polyline v-if="stackGuard" :points="`${stackGuard.x1}, ${stackGuard.y} ${stackGuard.x2}, ${stackGuard.y}`"
        fill="none" stroke="#d2dae0" stroke-width=".5"/>

      <!-- eslint-disable -->
      <template v-for="{ top, bot} in stack">
        <template v-for="rect in top">
          <rect :x="rect.x" :y="rect.y" rx="1" ry="3" :width="rect.width" :height="rect.height" :fill="rect.fill" class="pointer"></rect>
        </template>
        <template v-for="rect in bot">
          <rect :x="rect.x" :y="rect.y" rx="1" ry="3" :width="rect.width" :height="rect.height" :fill="rect.fill" class="pointer"></rect>
        </template>
      </template>
      <!-- eslint-enable -->
    </svg>

    <defs>
      <filter x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" id="svg-line-point-text">
        <feFlood flood-color="white" flood-opacity=".6" result="FLOOD" />
        <feMerge>
          <feMergeNode in="FLOOD" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <!-- Метки кругами позиционируемые по %, их форма не искажается при изменении соотношения сторон -->
    <g v-if="topLabels.length > 0">
      <text filter="url(#svg-line-point-text)" v-for="(tLabel, index) in topLabels" :key="index"
        class="pointLabel" fill="black"
        :x="`${tLabel.x}%`" :y="`${tLabel.y}%`">
        <tspan dy="-8px">{{ tLabel.label }}</tspan>
      </text>
    </g>

    <!-- Метки кругами позиционируемые по %, их форма не искажается при изменении соотношения сторон -->
    <g v-if="botLabels.length > 0">
      <text filter="url(#svg-line-point-text)" v-for="(bLabel, index) in botLabels" :key="index"
        class="pointLabel" fill="black"
        :x="`${bLabel.x}%`" :y="`${bLabel.y}%`">
        <tspan dy="18px">{{ bLabel.label }}</tspan>
      </text>
    </g>

  </svg>
</template>

<script>
export default {
  inject: ['plotSettings', 'getViewBox', 'childDataUpdated'],
  props: {
    data: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      domainRange: null,
      stackRange: null,
      stackGuard: null,
      stack: [],
      topLabels: [],
      botLabels: []
    }
  },
  computed: {
    viewBox () {
      return this.getViewBox()
    },
    svg () {
      return this.plotSettings().chartArea
    },
    barWidth () {
      return (this.viewBox.width / 2) / this.plotSettings().axis.windowSize
    }
  },
  watch: {
    data (_new, _old) {
      this.childDataUpdated()
    }
  },
  methods: {
    getDomainRange () {
      this.recalculateStackRange()
      this.domainRange = {
        xDRange: { min: Math.min(...this.data.map(d => d.x)), max: Math.max(...this.data.map(d => d.x)), absolute: true },
        yDRange: { min: 0, max: this.stackRange.topMax + this.stackRange.botMax, absolute: false }
      }
      return this.domainRange
    },
    render (mappers) {
      // порядок важен
      this.renderStackGuard(mappers)
      this.renderStack(mappers)
      this.renderLabels(mappers)
    },
    recalculateStackRange () {
      this.stackRange = this.data.reduce(({ topMax, botMax }, { top, bot }) => {
        const topSum = top.bars.reduce((sum, { value }) => { return value + sum }, 0)
        const botSum = bot.bars.reduce((sum, { value }) => { return value + sum }, 0)
        return {
          topMax: topMax ? (topSum > topMax ? topSum : topMax) : topSum,
          botMax: botMax ? (botSum > botMax ? botSum : botMax) : botSum
        }
      }, { topMax: null, botMax: null })
    },
    renderStackGuard (mappers) {
      const xAdjustment = mappers.length.x(1 / 2) / 2
      const x1 = Math.min(...this.data.map((d, index) => mappers.real.x(index))) - xAdjustment
      const x2 = Math.max(...this.data.map((d, index) => mappers.real.x(index))) + xAdjustment

      const adv = mappers.realtiveToAbsolute.y(this.stackRange.botMax, this.domainRange.yDRange)
      const y = mappers.real.y(adv)

      this.stackGuard = { x1: x1 || 0, x2: x2 || 0, y: y || 0 }
    },
    renderStack (mappers) {
      const barWidth = this.barWidth
      const stackAxisY = this.stackGuard.y

      this.stack = this.data.map(({ top, bot }, index) => {
        if (mappers.real.x(index) === null) {
          return null
        }

        const topStack = top.bars.reduce((acc, { value, color }) => {
          const height = mappers.length.y(value)
          const rect = {
            x: mappers.real.x(index) - barWidth / 2,
            y: (acc.length > 0 ? acc[0].y : stackAxisY) - height,
            width: barWidth,
            height: height,
            fill: color
          }
          acc.unshift(rect)
          return acc
        }, [])

        const botStack = bot.bars.reduce((acc, { value, color }, index2) => {
          const height = mappers.length.y(value)
          const rect = {
            x: mappers.real.x(index) - barWidth / 2,
            y: (acc.length > 0 ? (acc[0].y + acc[0].height) : stackAxisY),
            width: barWidth,
            height: height,
            fill: color
          }
          acc.unshift(rect)
          return acc
        }, [])

        return { top: topStack, bot: botStack }
      }).filter(s => s !== null)
    },
    renderLabels (mappers) {
      // TODO: за один проход по this.data просчитать все метки

      this.topLabels = Array.isArray(this.data)
        ? this.data.map(({ top, x }) => {
          const rv = this.stackRange.botMax + top.bars.reduce((sum, { value }) => { return value + sum }, 0)
          const adv = mappers.realtiveToAbsolute.y(rv, this.domainRange.yDRange)
          return {
            x: mappers.percent.x(x),
            y: mappers.percent.y(adv),
            label: top.label
          }
        }).filter(({ x, y, label }) => label !== null && x != null) // если label в исходных данных не указали, то не рисуем их
        : []

      this.botLabels = Array.isArray(this.data)
        ? this.data.map(({ bot, x }) => {
          const rv = this.stackRange.botMax - bot.bars.reduce((sum, { value }) => { return value + sum }, 0)
          const adv = mappers.realtiveToAbsolute.y(rv, this.domainRange.yDRange)
          return {
            x: mappers.percent.x(x),
            y: mappers.percent.y(adv),
            label: bot.label
          }
        }).filter(({ x, y, label }) => label !== null && x != null)
        : []
    }
  }
}
</script>

<style lang="scss" scoped>
svg * {
  overflow: visible;
  vector-effect: non-scaling-stroke;
}
.pointLabel {
  text-anchor: middle;
  font-size: .875rem;
}
</style>
